<script setup>
import {useSDSStore} from "@/stores/sdsStore";
import {computed, onMounted} from "vue";

const sdsStore = useSDSStore();
const latest = computed(() => sdsStore.getLatest);

onMounted(() => {
  useSDSStore().fetchInbox();
  useSDSStore().fetchHistory();
})

</script>

<template>
  <v-footer app color="surface-light" name="footer">
    <v-row class="pa-1 d-flex flex-row width-100" cols="24">
      <v-col class="align-content-center" cols="1">
        <div class="border newMess " >New SDS
          <v-card class="p-4 ">
            {{ sdsStore.messages.length }}
          </v-card>
        </div>
      </v-col>
      <v-col cols="22">
        <table>
          <thead>
          <tr>
            <th>Operator ID</th>
            <th>Time</th>
            <th>Message</th>
          </tr>
          </thead>
          <tbody>
          <tr style="height: 40px;">
            <td>{{ latest ? latest.senderName : '-'}}</td>
            <td>{{ latest ? new Date(latest.time).toLocaleDateString() + " " + new Date(latest.time).toLocaleTimeString() : '-' }}</td>
            <td class="messRow">{{ latest ? latest.message : '-' }}</td>
          </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

  </v-footer>
</template>

<style scoped>
.v-footer {
  border-top: 1px solid #ccc;
  font-size: 13px;
}

.newMess {
  text-align: center;
  width: fit-content;
  padding: 2px;
}

table {
  width: 100%;
}

th {
  font-weight: bold;
  height: 16px;
}

th, tr, td {
  border: 1px solid #ccc;
  text-align: center;
}

td.messRow {

  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>